import React, { Fragment, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { KTSVG } from '../../../_metronic/helpers'
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { components } from "react-select";
import { workingdaytypeInitialsForApp, workingdaytypeInitialsForUpdate } from './interfaces/workingdaytypeClass';
import { addAccountWorkingDayTypeAsync, updateAccountWorkingDayTypeAsync, resetSelectedRecordObjectInState } from './workingdaytypeSlice'
import { Formik } from 'formik';
import * as yup from 'yup';
import { ShowToast } from '../../../common/Toastr';
import { determineCommaSeprater, dropDownSelectionStyles, formatNumberCustomoriginalapiv2, getValueFromResource, parseLocalizedNumber } from '../../../common/timeLiveFunction';
import CanvasLoader from '../../../common/CanvasLoader';
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';

export const cultureDecimalValidator = (
  cultureInfoName: string,
  dispatch: any,
  t: any,
  {
    requiredMsg,
    min,
    max,
    minMsg,
    maxMsg,
    decimals = 2,
  }: {
    requiredMsg: string;
    min?: number;
    max?: number;
    minMsg?: string;
    maxMsg?: string;
    decimals?: number;
  }
) =>
  yup
    .string()
    .required(getValueFromResource(requiredMsg, dispatch, t))
    .test('culture-decimal-validation', function (value) {
      if (!value) return true;

      const isComma = determineCommaSeprater(cultureInfoName.toString());

      const regex = isComma
        ? new RegExp(`^\\d+(,\\d{1,${decimals}})?$`)
        : new RegExp(`^\\d+(\\.\\d{1,${decimals}})?$`);

      if (!regex.test(value)) {
        return this.createError({
          message: isComma
            ? `Only numeric values allowed (max ${decimals} decimals with comma).`
            : `Only numeric values allowed (max ${decimals} decimals with dot).`,
        });
      }

      const numericValue = isComma
        ? Number(value.replace(',', '.'))
        : Number(value);

      if (isNaN(numericValue)) {
        return this.createError({ message: 'Invalid numeric value.' });
      }

      if (min !== undefined && numericValue < min) {
        return this.createError({
          message: getValueFromResource(
            minMsg || 'Value is below allowed minimum',
            dispatch,
            t
          ),
        });
      }

      if (max !== undefined && numericValue > max) {
        return this.createError({
          message: getValueFromResource(
            maxMsg || 'Value exceeds allowed maximum',
            dispatch,
            t
          ),
        });
      }

      return true;
    });

export const integerOnlyValidator = (
  dispatch: any,
  t: any,
  {
    requiredMsg,
    min = 0,
    minMsg,
  }: {
    requiredMsg: string;
    min?: number;
    minMsg?: string;
  }
) =>
  yup
    .string()
    .required(getValueFromResource(requiredMsg, dispatch, t))
    .matches(/^\d+$/, 'Only whole numbers are allowed')
    .test('min-check', function (value) {
      if (!value) return true;

      const num = Number(value);

      if (num < min) {
        return this.createError({
          message: getValueFromResource(
            minMsg || 'Value must be equal to or greater than zero',
            dispatch,
            t
          ),
        });
      }

      return true;
    });




const WorkingDayTypeForm = (props: any) => {
  const formikRef = useRef<any>(null);
  const { t } = props;
  const dispatch = useAppDispatch();
  const defaultFocusRef = useRef<HTMLInputElement>(null);
  const { maxMenuHeight, manageTerminologyList,cultureInfoName,decimalFormat,decimalPlaces } = useAppSelector(state => state.globalState);
  const { selectedRecord, isLoading } = useAppSelector((state) => state.workingdaytype);
  const [WorkingDaysArray, SetWorkingDaysArray] = useState<any | ''>([]);
  const [WeekStartDaysArray, SetWeekStartDaysArray] = useState<any | ''>([]);
  const [selectedOptionWSDAY, setSelectedOptionWSDAY] = useState<{ [object: string]: any }>();
  const [OptionSelected, SetOptionSelected] = useState<any | ''>([]);
  const [currentFieldsData, setCurrentFieldsData] = useState<any>(workingdaytypeInitialsForApp);
  const [TimesheetPeriodTypesArray, SetTimesheetPeriodTypesArray] = useState<any | ''>([]);
  const [selectedOptionTPT, setSelectedOptionTPT] = useState<{ [object: string]: any }>();
  const [isCanvasLoader, setIsCanvasLoader] = useState(true);
  const defaultSelectedOptions: any = [
    { value: 1, label: 'Monday' },
    { value: 2, label: 'Tuesday' },
    { value: 3, label: 'Wednesday' },
    { value: 4, label: 'Thursday' },
    { value: 5, label: 'Friday' }
  ];
  const [selectedOptions, setSelectedOptions] = useState<any>(defaultSelectedOptions);
  const [activeTab, setActiveTab] = useState(0);
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);

  const resetTabs = () => {
    setActiveTab(0);
  };

  const handleTabClick = (index: number) => {
    setActiveTab(index);
  };

  const handleMultiSelectChange = (values: any, selectedOptions: any) => {
    setSelectedOptions(selectedOptions);
    setCurrentFieldsData({ ...values, 'WorkingDayNo': selectedOptions });

  };

  useEffect(() => {
    getWorkingDaysAsync();
    getSystemTimesheetPeriodTypesAsync();
    setIsCanvasLoader(false);
  }, [])

  useEffect(() => {
    setIsCanvasLoader(true);
    let stateItem: any = {}
    if (Object.keys(selectedRecord).length > 0) {
      const tempObj: any = selectedRecord;
      Object.keys(workingdaytypeInitialsForUpdate).map((item) => {
        return stateItem[item] = tempObj[item];
      })


      stateItem.HoursPerDay = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.HoursPerDay, 2);      
      stateItem.MinimumHoursPerDay = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.MinimumHoursPerDay, 2);      
      stateItem.MaximumHoursPerDay = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.MaximumHoursPerDay, 2);
      stateItem.MinimumHoursPerWeek = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.MinimumHoursPerWeek, 2);
      stateItem.MaximumHoursPerWeek = formatNumberCustomoriginalapiv2(cultureInfoName.toString(), stateItem.MaximumHoursPerWeek, 2);
      stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
      stateItem.LockAllPreviousTimesheets = stateItem.LockAllPreviousTimesheets === 'Yes' ? true : false;
      stateItem.LockAllFutureTimesheets = stateItem.LockAllFutureTimesheets === 'Yes' ? true : false;
      stateItem.EnableBalanceValidationForTimeOff = stateItem.EnableBalanceValidationForTimeOff === 'Yes' ? true : false;
      stateItem.ShowClockStartEndEmployee = stateItem.ShowClockStartEndEmployee === 'Yes' ? true : false;
      stateItem.TimesheetOverdueAfterDays = stateItem.TimesheetOverdueAfterDays ? stateItem.TimesheetOverdueAfterDays : 0;
      stateItem.LockPreviousTimesheetPeriods = stateItem.LockPreviousTimesheetPeriods ? stateItem.LockPreviousTimesheetPeriods : 0;
      stateItem.LockFutureTimsheetPeriods = stateItem.LockFutureTimsheetPeriods ? stateItem.LockFutureTimsheetPeriods : 0;
      stateItem.LockAllPeriodExceptPrevious = stateItem.LockAllPeriodExceptPrevious ? stateItem.LockAllPeriodExceptPrevious : 0;
      stateItem.LockAllPeriodExceptNext = stateItem.LockAllPeriodExceptNext ? stateItem.LockAllPeriodExceptNext : 0;
      stateItem.LockPreviousNextMonthTimesheetOn = stateItem.LockPreviousNextMonthTimesheetOn ? stateItem.LockPreviousNextMonthTimesheetOn : 0;
      



      setSelectedOptionTPT({ value: stateItem.AccountTimesheetPeriodTypeId, label: stateItem.SystemTimesheetPeriodType });
      setSelectedOptionWSDAY({ value: stateItem.WeekStartDay, label: stateItem.WeekStartsOn });
      let newObject1: any[] = [];
      if (stateItem.WorkingDayNo !== null) {
        let a1 = stateItem.WorkingDayNo.split(',').map(Number)
        let a2 = stateItem.WorkingDays.split(',').map(String)
        a1.map((item: any, i: any) => { newObject1.push({ 'value': item, 'label': a2.at(i) }) })
      }
      setSelectedOptions(newObject1);
      stateItem.WorkingDayNo = newObject1;
      setCurrentFieldsData(stateItem);
      setIsCanvasLoader(false);
    }
    else {
      setSelectedOptions(defaultSelectedOptions);
      workingdaytypeInitialsForApp.WorkingDayNo = defaultSelectedOptions;
      if (Object.keys(TimesheetPeriodTypesArray).length > 0) {
        setSelectedOptionTPT({ value: TimesheetPeriodTypesArray[0].value, label: TimesheetPeriodTypesArray[0].label });
        workingdaytypeInitialsForApp.AccountTimesheetPeriodTypeId = TimesheetPeriodTypesArray[0].value;
      }
      if (Object.keys(WeekStartDaysArray).length > 0) {
        setSelectedOptionWSDAY({ value: WeekStartDaysArray[0].value, label: WeekStartDaysArray[0].label });
        workingdaytypeInitialsForApp.WeekStartDay = WeekStartDaysArray[0].value;
      }

      setCurrentFieldsData(workingdaytypeInitialsForApp);
      setIsCanvasLoader(false);
    }
    if (defaultFocusRef.current) {
      defaultFocusRef.current.focus();
    }
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
    resetTabs();

  }, [selectedRecord])

  const getWorkingDaysAsync = async () => {
    const response = await fetchAPI("api/DropDown/GetWorkingDays", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
    const json = await response.json();
    json.map((item: any) => {
      item.value = item.WorkingDayNo;
      item.label = item.WorkingDay;
    });
    SetWeekStartDaysArray(json);
    SetWorkingDaysArray(json);
    setSelectedOptionWSDAY({ value: json[0].value, label: json[0].label });
  }

  const getSystemTimesheetPeriodTypesAsync = async () => {
    const response = await fetchAPI("api/TimeSheetPolicies/GetvueAccountTimesheetPeriodTypesByAccountId", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
    const json = await response.json();
    json.map((item: any) => {
      item.value = item.AccountTimesheetPeriodTypeId;
      item.label = item.SystemTimesheetPeriodType;
      delete item.AccountId;
      delete item.AccountTimesheetPeriodId;
      delete item.CreatedByEmployeeId;
      delete item.CreatedOn;
      delete item.InitialDayOfTheMonth;
      delete item.ModifiedByEMployeeId;
      delete item.ModifiedOn;
      delete item.IsDisabled;
      delete item.AccountTimesheetPeriodTypeId;
      delete item.ModifiedByEmployeeId;
      delete item.SystemInitialDayOfFirstPeriod;
      delete item.SystemInitialDayOfLastPeriod;
      delete item.SystemInitialDaysOfThePeriod;
      delete item.SystemInitialDaysOfThePeriodId;
      delete item.SystemTimesheetPeriodType;
      delete item.SystemTimesheetPeriodTypeId;
      delete item.TimesheetPeriodEffectiveDate;
    });
    SetTimesheetPeriodTypesArray(json);
    setSelectedOptionTPT({ value: json[0].value, label: json[0].label });
  }

  const handleOptionChange = (values: any, data: any, isTPT: number) => {
    if (isTPT === 1) {
      setSelectedOptionWSDAY(data);
      setCurrentFieldsData({ ...values, 'WeekStartDay': data.value });
    }
    if (isTPT === 2) {
      setSelectedOptionTPT(data);
      setCurrentFieldsData({ ...values, 'AccountTimesheetPeriodTypeId': data.value });
    }
  }

  const handleTextChange = (e: any) => {
    setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value) });
  }

  const handleSubmit = (values: any) => {
    const updatedValues = {
      ...values,
      HoursPerDay: parseLocalizedNumber(values.HoursPerDay),
      MinimumHoursPerDay: parseLocalizedNumber(values.MinimumHoursPerDay),
      MaximumHoursPerDay: parseLocalizedNumber(values.MaximumHoursPerDay),
      MinimumHoursPerWeek: parseLocalizedNumber(values.MinimumHoursPerWeek),
      MaximumHoursPerWeek: parseLocalizedNumber(values.MaximumHoursPerWeek)
    };
    console.log('handleSubmit :',updatedValues)

    if (Object.keys(selectedRecord).length > 0) {
      dispatch(updateAccountWorkingDayTypeAsync(updatedValues))
        .unwrap()
        .then((originalPromiseResult) => {
          originalPromiseResult.StatusCode === "200" ?
            ShowToast("Working Day Type Update Successfully", 'Success', "success", "toast-top-right") :
            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
        })
        .catch((rejectedValueOrSerializedError) => {
        })
    }
    else {
      dispatch(addAccountWorkingDayTypeAsync(updatedValues))
        .unwrap()
        .then((originalPromiseResult) => {
          originalPromiseResult.StatusCode === "201" ?
            ShowToast("Working Day Type Added Successfully", 'Success', "success", "toast-top-right") :
            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
        })
        .catch((rejectedValueOrSerializedError) => {

        })
    }
    resetTabs();
   if (closeButtonRef.current) {
     closeButtonRef.current.click();
   }
  }

  const handleCloseOnClickEvent = () => {
    dispatch(resetSelectedRecordObjectInState());
  }
  const ShowWeekStartDay = selectedOptionTPT?.label.toLowerCase() === 'weekly' || selectedOptionTPT?.label.toLowerCase() === 'biweekly';

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={currentFieldsData}
        enableReinitialize={true}
        onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
        validationSchema={yup.object().shape({
          AccountWorkingDayType: yup
            .string()
            .label
            // (t('AccountWorkingDayType'))
            (getValueFromResource('AccountWorkingDayType', dispatch, t))

            .trim()
            .required
            // (t('Working Day Type field is Required')),
            (getValueFromResource('Working Day Type field is Required', dispatch, t)),
          HoursPerDay: cultureDecimalValidator(
            cultureInfoName.toString(),
            dispatch,
            t,
            {
              requiredMsg: 'Hours Per Day field is Required',
              max: 24,
              maxMsg: getValueFromResource('Hours Per Day must be equal to or less than 24', dispatch, t),
            }
          ),

          MinimumHoursPerDay: cultureDecimalValidator(
            cultureInfoName.toString(),
            dispatch,
            t,
            {
              requiredMsg: 'Minimum Hours Per Day field is Required',
              max: 24,
              maxMsg: getValueFromResource('Minimum Hours Per Day must be equal to or less than 24', dispatch, t),
            }
          ),

          MaximumHoursPerDay: cultureDecimalValidator(
            cultureInfoName.toString(),
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Maximum Hours Per Day field is Required', dispatch, t),
              max: 24,
              maxMsg: getValueFromResource('Value must be equal to or less than 24', dispatch, t),
            }
          ),
          MinimumHoursPerWeek: cultureDecimalValidator(
            cultureInfoName.toString(),
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Minimum Hours Per Period field is Required', dispatch, t),
              min: 0,
              minMsg: getValueFromResource('Value must be equal to or greater than zero', dispatch, t),
            }
          ),

          MaximumHoursPerWeek: cultureDecimalValidator(
            cultureInfoName.toString(),
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Maximum Hours Per Period field is Required', dispatch, t),
              min: 0,
              minMsg: getValueFromResource('Value must be equal to or greater than zero', dispatch, t),
            }
          ),


           TimesheetOverdueAfterDays: integerOnlyValidator(
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Timesheet Overdue field is Required', dispatch, t),
              min: 0,
              minMsg: getValueFromResource('Value must be equal to or greater than zero', dispatch, t),
            }
          ),    
          LockPreviousTimesheetPeriods: integerOnlyValidator(
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Lock Previous Timesheet Period field is Required', dispatch, t),
              min: 0,
              minMsg:  getValueFromResource('Value must be equal to or greater than zero', dispatch, t),
            }
          ),
          LockFutureTimsheetPeriods: integerOnlyValidator(
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Lock Next Timesheet Period field is Required', dispatch, t),
              min: 0,
              minMsg:  getValueFromResource('Value must be equal to or greater than zero', dispatch, t),
            }
          ),
           LockAllPeriodExceptPrevious: integerOnlyValidator(
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Lock All Periods Except Previous field is Required', dispatch, t),
              min: 0,
              minMsg: getValueFromResource('Value must be equal to or greater than zero', dispatch, t),
            }
          ),
           LockAllPeriodExceptNext: integerOnlyValidator(
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Lock All Periods Except Next field is Required', dispatch, t),
              min: 0,
              minMsg: getValueFromResource('Value must be equal to or greater than zero', dispatch, t),
            }
          ),    
           LockPreviousNextMonthTimesheetOn: integerOnlyValidator(
            dispatch,
            t,
            {
              requiredMsg: getValueFromResource('Lock Previous Timesheets On field is Required', dispatch, t),
              min: 0,
              minMsg: getValueFromResource('Value must be equal to or greater than zero', dispatch, t),
            }
          ),        
          WorkingDayNo: yup.array()
            .min(1,
              // t('Please select at least one option'))
              getValueFromResource('Please select at least one option', dispatch, t))

            .required
            // (t('You should have atleast one day selected')),
            (getValueFromResource('You should have atleast one day selected', dispatch, t))


        })}>
        {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
          <Fragment>
            <div className='card-body' style={{ padding: '0rem 2.25rem' }}>
              {isCanvasLoader ? <CanvasLoader /> : <>
                {isLoading ?
                  <div className="col-md-12">
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      <span className='spinner-border spinner-border-md ms-2'></span>
                    </span>
                  </div>
                  : <>
                    {/* <div className='row'> */}
                    <div className='card-header' style={{ marginLeft: '-30px' }}>
                      <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-4' role='tablist'>
                        <li className="nav-item">
                          <a
                            className={activeTab === 0 ? 'nav-link cursor-pointer active  tabFontWeight' : 'nav-link cursor-pointer tabFontWeight'}
                            onClick={() => handleTabClick(0)}
                          >
                            {/* {t('Basic')} */}
                            {getValueFromResource('Basic', dispatch, t)}
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={activeTab === 1 ? 'nav-link cursor-pointer active  tabFontWeight' : 'nav-link cursor-pointer tabFontWeight'}
                            onClick={() => handleTabClick(1)}
                          >
                            {/* {t('Hour Validation')} */}
                            {getValueFromResource('Hour Validation', dispatch, t)}
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className={activeTab === 2 ? 'nav-link cursor-pointer active  tabFontWeight' : 'nav-link cursor-pointer tabFontWeight'}
                            onClick={() => handleTabClick(2)}
                          >
                            {/* {t('Locking Timesheet')} */}
                            {getValueFromResource('Locking Timesheet', dispatch, t)}
                          </a>
                        </li>
                        {/* <li className="nav-item">
                          <a
                            className={activeTab === 3 ? 'nav-link cursor-pointer active  tabFontWeight' : 'nav-link cursor-pointer tabFontWeight'}
                            onClick={() => handleTabClick(3)}
                          >
                            {getValueFromResource('Percentage Validation', dispatch, t)}

                          </a>
                        </li> */}
                        <li className="nav-item">
                          <a
                            className={activeTab === 4 ? 'nav-link cursor-pointer active  tabFontWeight' : 'nav-link cursor-pointer tabFontWeight'}
                            onClick={() => handleTabClick(4)}
                          >
                            {/* {t('Working Days')} */}
                            {getValueFromResource('Working Days', dispatch, t)}
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="tab-content mt-5" id="myTabContent">

                      <div className={activeTab === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} role="tabpanel">
                        <div className='row'>
                          <div className="col-md-12 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Working Day Type')} */}
                              {getValueFromResource('Working Day Type', dispatch, t)}
                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='AccountWorkingDayType'
                              name='AccountWorkingDayType'
                              value={values.AccountWorkingDayType}
                              onChange={handleChange('AccountWorkingDayType')}
                              ref={defaultFocusRef}
                            // onBlur={() => setFieldTouched('AccountWorkingDayType')}
                            />
                            <div style={{ paddingRight: 5 }}>
                              {touched.AccountWorkingDayType && errors.AccountWorkingDayType &&
                                <p className='errorMsg'>{errors.AccountWorkingDayType as string}</p>
                              }
                            </div>
                          </div>

                        </div>
                        <div className='row  mt-2'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                              {/* {t('Timesheet Overdue')} */}
                              {getValueFromResource('Timesheet Overdue', dispatch, t)}
                              <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-workingDayForm"
                                data-tooltip-content={getValueFromResource("Specify the number of days after a timesheet period ends before it is considered overdue. Enter 0 to mark it overdue immediately after the period ends.", dispatch, t)}
                              >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                              </div>

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='TimesheetOverdueAfterDays'
                              name='TimesheetOverdueAfterDays'
                              value={values.TimesheetOverdueAfterDays}
                              // onChange={handleChange('TimesheetOverdueAfterDays')}
                               onChange={(e) => {
                                if (!/^\d*$/.test(e.target.value)) return; 
                                handleChange(e); 
                              }}  
                              onBlur={() => setFieldTouched('TimesheetOverdueAfterDays')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.TimesheetOverdueAfterDays && errors.TimesheetOverdueAfterDays &&
                                <p className='errorMsg'>{errors.TimesheetOverdueAfterDays as string}</p>
                              }
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Timesheet Period Type')} */}
                              {getValueFromResource('Timesheet Period Type', dispatch, t)}

                            </label>
                            <Select
                              value={selectedOptionTPT}
                              className="basic-single"
                              classNamePrefix="select"
                              name="TimesheetPeriodTypeList"
                              options={TimesheetPeriodTypesArray}
                              styles={dropDownSelectionStyles}
                              maxMenuHeight={maxMenuHeight}
                              onChange={e => handleOptionChange(values, e, 2)}
                            />
                          </div>

                        </div>
                        <div className='row  mt-2'>
                          {ShowWeekStartDay ? (
                            <div className="col-md-6 mb-3">
                              <label className="fs-7 fw-normal mb-2">
                                {/* {t('Week Start Day')} */}
                                {getValueFromResource('Week Start Day', dispatch, t)}

                              </label>
                              <Select
                                value={selectedOptionWSDAY}
                                className="basic-single"
                                classNamePrefix="select"
                                name="WeekStartDayList"
                                options={WeekStartDaysArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                                onChange={e => handleOptionChange(values, e, 1)}
                              />
                            </div>
                          ) : null}
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Show Clock Start End')} */}
                              {getValueFromResource('Show Clock Start End', dispatch, t)}

                            </label>
                            <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input  mt-2'
                                type='checkbox'
                                id='ShowClockStartEndEmployee'
                                name='ShowClockStartEndEmployee'
                                checked={values.ShowClockStartEndEmployee}
                                onChange={handleChange('ShowClockStartEndEmployee')}
                              />
                              <label className='form-check-label'>
                                {/* {t('Enabled')} */}
                                {getValueFromResource('Enabled', dispatch, t)}

                              </label>
                            </div>
                          </div>
                        </div>

                      </div>


                      <div
                        className={activeTab === 1 ? 'tab-pane fade show active' : 'tab-pane fade'}
                        role="tabpanel">
                        <div className='row'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Hours Per Day')} */}
                              {getValueFromResource('Hours Per Day', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='HoursPerDay'
                              name='HoursPerDay'
                              value={values.HoursPerDay}
                              onChange={handleChange('HoursPerDay')}
                              onBlur={() => setFieldTouched('HoursPerDay')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.HoursPerDay && errors.HoursPerDay &&
                                <p className='errorMsg'>{errors.HoursPerDay as string}</p>
                              }
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Minimum Hours Per Day')} */}
                              {getValueFromResource('Minimum Hours Per Day', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='MinimumHoursPerDay'
                              name='MinimumHoursPerDay'
                              value={values.MinimumHoursPerDay}
                              onChange={handleChange('MinimumHoursPerDay')}
                              onBlur={() => setFieldTouched('MinimumHoursPerDay')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.MinimumHoursPerDay && errors.MinimumHoursPerDay &&
                                <p className='errorMsg'>{errors.MinimumHoursPerDay as string}</p>
                              }
                            </div>
                          </div>
                        </div>
                        <div className='row  mt-2'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Maximum Hours Per Day')} */}
                              {getValueFromResource('Maximum Hours Per Day', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='MaximumHoursPerDay'
                              name='MaximumHoursPerDay'
                              value={values.MaximumHoursPerDay}
                              onChange={handleChange('MaximumHoursPerDay')}
                              onBlur={() => setFieldTouched('MaximumHoursPerDay')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.MaximumHoursPerDay && errors.MaximumHoursPerDay &&
                                <p className='errorMsg'>{errors.MaximumHoursPerDay as string}</p>
                              }
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Minimum Hours Per Period')} */}
                              {getValueFromResource('Minimum Hours Per Period', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='MinimumHoursPerWeek'
                              name='MinimumHoursPerWeek'
                              value={values.MinimumHoursPerWeek}
                              onChange={handleChange('MinimumHoursPerWeek')}
                              onBlur={() => setFieldTouched('MinimumHoursPerWeek')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.MinimumHoursPerWeek && errors.MinimumHoursPerWeek &&
                                <p className='errorMsg'>{errors.MinimumHoursPerWeek as string}</p>
                              }
                            </div>
                          </div>
                        </div>
                        <div className='row  mt-2'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Maximum Hours Per Period')} */}
                              {getValueFromResource('Maximum Hours Per Period', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='MaximumHoursPerWeek'
                              name='MaximumHoursPerWeek'
                              value={values.MaximumHoursPerWeek}
                              onChange={handleChange('MaximumHoursPerWeek')}
                              onBlur={() => setFieldTouched('MaximumHoursPerWeek')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.MaximumHoursPerWeek && errors.MaximumHoursPerWeek &&
                                <p className='errorMsg'>{errors.MaximumHoursPerWeek as string}</p>
                              }
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                              {/* {t('Enable Balance Validation For TimeOff')} */}
                              {getValueFromResource('Enable Balance Validation For TimeOff', dispatch, t)}
                              <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-workingDayForm"
                                data-tooltip-content={getValueFromResource("Validate available time off balances before allowing time off requests associated with this working day type.", dispatch, t)}
                              >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                              </div>

                            </label>
                            <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input  mt-2'
                                type='checkbox'
                                checked={values.EnableBalanceValidationForTimeOff}
                                id='EnableBalanceValidationForTimeOff'
                                name='EnableBalanceValidationForTimeOff'
                                onChange={handleChange('EnableBalanceValidationForTimeOff')}
                              />
                              <label className='form-check-label'>
                                {/* {t('Enabled')} */}
                                {getValueFromResource('Enabled', dispatch, t)}

                              </label>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div
                        className={activeTab === 2 ? 'tab-pane fade show active' : 'tab-pane fade'}
                        role="tabpanel">
                        <div className='row'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                              {/* {t('Lock Previous Timesheet Period')} */}
                              {getValueFromResource('Lock Previous Timesheet Period', dispatch, t)}
                              <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-workingDayForm"
                                data-tooltip-content={getValueFromResource("Prevent users from editing timesheets older than the specified number of previous periods.", dispatch, t)}
                              >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                              </div>

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='LockPreviousTimesheetPeriods'
                              name='LockPreviousTimesheetPeriods'
                              value={values.LockPreviousTimesheetPeriods}
                              onChange={(e) => {
                                if (!/^\d*$/.test(e.target.value)) return; 
                                handleChange(e); 
                              }}                         
                              onBlur={() => setFieldTouched('LockPreviousTimesheetPeriods')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.LockPreviousTimesheetPeriods && errors.LockPreviousTimesheetPeriods &&
                                <p className='errorMsg'>{errors.LockPreviousTimesheetPeriods as string}</p>
                              }
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                              {/* {t('Lock Next Timesheet Period')} */}
                              {getValueFromResource('Lock Next Timesheet Period', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='LockFutureTimsheetPeriods'
                              name='LockFutureTimsheetPeriods'
                              value={values.LockFutureTimsheetPeriods}
                              onChange={(e) => {
                                if (!/^\d*$/.test(e.target.value)) return; 
                                handleChange(e); 
                              }}                         
                              onBlur={() => setFieldTouched('LockFutureTimsheetPeriods')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.LockFutureTimsheetPeriods && errors.LockFutureTimsheetPeriods &&
                                <p className='errorMsg'>{errors.LockFutureTimsheetPeriods as string}</p>
                              }
                            </div>
                          </div>
                        </div>
                        <div className='row mt-2'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                              {/* {t('Lock All Period Except Previous')} */}
                              {getValueFromResource('Lock All Previous Periods Except', dispatch, t)}
                              <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-workingDayForm"
                                data-tooltip-content={getValueFromResource("Lock all previous timesheet periods except the specified number of most recent periods.", dispatch, t)}
                              >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                              </div>

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='LockAllPeriodExceptPrevious'
                              name='LockAllPeriodExceptPrevious'
                              value={values.LockAllPeriodExceptPrevious}                             
                               onChange={(e) => {
                                if (!/^\d*$/.test(e.target.value)) return; 
                                handleChange(e); 
                              }}  
                              onBlur={() => setFieldTouched('LockAllPeriodExceptPrevious')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.LockAllPeriodExceptPrevious && errors.LockAllPeriodExceptPrevious &&
                                <p className='errorMsg'>{errors.LockAllPeriodExceptPrevious as string}</p>
                              }
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                              {/* {t('Lock All Period Except Next')} */}
                              {getValueFromResource('Lock All Next Periods Except', dispatch, t)}
                              <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-workingDayForm"
                                data-tooltip-content={getValueFromResource("Prevent users from entering future timesheets except for the specified number of upcoming periods.", dispatch, t)}
                              >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                              </div>

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='LockAllPeriodExceptNext'
                              value={values.LockAllPeriodExceptNext}
                              name='LockAllPeriodExceptNext'
                              // onChange={handleChange('LockAllPeriodExceptNext')}
                                onChange={(e) => {
                                if (!/^\d*$/.test(e.target.value)) return; 
                                handleChange(e); 
                              }}  
                              onBlur={() => setFieldTouched('LockAllPeriodExceptNext')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.LockAllPeriodExceptNext && errors.LockAllPeriodExceptNext &&
                                <p className='errorMsg'>{errors.LockAllPeriodExceptNext as string}</p>
                              }
                            </div>
                          </div>
                        </div>
                        <div className='row mt-2'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                              {/* {t('Lock All Previous Timesheets')} */}
                              {getValueFromResource('Lock All Previous Timesheets', dispatch, t)}
                              <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-workingDayForm"
                                data-tooltip-content={getValueFromResource("Prevent all edits to timesheets belonging to past periods.", dispatch, t)}
                              >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                              </div>

                            </label>
                            <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input  mt-2'
                                type='checkbox'
                                checked={values.LockAllPreviousTimesheets}
                                id='LockAllPreviousTimesheets'
                                name='LockAllPreviousTimesheets'
                                onChange={handleChange('LockAllPreviousTimesheets')} 
                              />
                              <label className='form-check-label'>
                                {/* {t('Enabled')} */}
                                {getValueFromResource('Enabled', dispatch, t)}

                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                              {/* {t('Lock All Next Timesheets')} */}
                              {getValueFromResource('Lock All Next Timesheets', dispatch, t)}
                              <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-workingDayForm"
                                data-tooltip-content={getValueFromResource("Prevent users from creating or editing future timesheet entries.", dispatch, t)}
                              >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                              </div>
                            </label>
                            <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input  mt-2'
                                type='checkbox'
                                checked={values.LockAllFutureTimesheets}
                                id='LockAllFutureTimesheets'
                                name='LockAllFutureTimesheets'
                                onChange={handleChange('LockAllFutureTimesheets')}
                              />
                              <label className='form-check-label'>
                                {/* {t('Enabled')} */}
                                {getValueFromResource('Enabled', dispatch, t)}

                              </label>
                            </div>
                          </div>
                        </div>
                        <div className='row'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                              {/* {t('Lock Previous Next Timesheets On')} */}
                              {getValueFromResource('Lock Previous Next Timesheets On', dispatch, t)}
                              <div
                                style={{ marginBottom: "2px" }}
                                data-tooltip-id="tooltip-workingDayForm"
                                data-tooltip-content={getValueFromResource("Specify the number of periods before and after the current period that remain available when previous or future timesheet locking is enabled.", dispatch, t)}
                              >
                                <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                              </div>

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='LockPreviousNextMonthTimesheetOn'
                              value={values.LockPreviousNextMonthTimesheetOn}
                              name='LockPreviousNextMonthTimesheetOn'
                              // onChange={handleChange('LockPreviousNextMonthTimesheetOn')}
                                onChange={(e) => {
                                if (!/^\d*$/.test(e.target.value)) return; 
                                handleChange(e); 
                              }}  
                              onBlur={() => setFieldTouched('LockPreviousNextMonthTimesheetOn')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.LockPreviousNextMonthTimesheetOn && errors.LockPreviousNextMonthTimesheetOn &&
                                <p className='errorMsg'>{errors.LockPreviousNextMonthTimesheetOn as string}</p>
                              }
                            </div>
                          </div>
                        </div>

                      </div>

                      {/* <div
                        className={activeTab === 3 ? 'tab-pane fade show active' : 'tab-pane fade'}
                        role="tabpanel">
                        <div className='row'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                            
                              {getValueFromResource('Minimum Percentage Per Day', dispatch, t)}
                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='MinimumPercentagePerDay'
                              value={values.MinimumPercentagePerDay}
                              name='MinimumPercentagePerDay'
                              onChange={handleChange('MinimumPercentagePerDay')}
                              onBlur={() => setFieldTouched('MinimumPercentagePerDay')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.MinimumPercentagePerDay && errors.MinimumPercentagePerDay &&
                                <p className='errorMsg'>{errors.MinimumPercentagePerDay as string}</p>
                              }
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                             
                              {getValueFromResource('Maximum Percentage Per Day', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='MaximumPercentagePerDay'
                              value={values.MaximumPercentagePerDay}
                              name='MaximumPercentagePerDay'
                              onChange={handleChange('MaximumPercentagePerDay')}
                              onBlur={() => setFieldTouched('MaximumPercentagePerDay')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.MaximumPercentagePerDay && errors.MaximumPercentagePerDay &&
                                <p className='errorMsg'>{errors.MaximumPercentagePerDay as string}</p>
                              }
                            </div>
                          </div>
                        </div>
                        <div className='row mt-2'>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                             
                              {getValueFromResource('Minimum Percentage Per Period', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='MinimumPercentagePerWeek'
                              value={values.MinimumPercentagePerWeek}
                              name='MinimumPercentagePerWeek'
                              onChange={handleChange('MinimumPercentagePerWeek')}
                              onBlur={() => setFieldTouched('MinimumPercentagePerWeek')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.MinimumPercentagePerWeek && errors.MinimumPercentagePerWeek &&
                                <p className='errorMsg'>{errors.MinimumPercentagePerWeek as string}</p>
                              }
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="fs-7 fw-normal mb-2">
                             
                              {getValueFromResource('Maximum Percentage Per Period', dispatch, t)}

                            </label>
                            <input
                              type="text"
                              className="form-control fs-7 fw-normal"
                              id='MaximumPercentagePerWeek'
                              value={values.MaximumPercentagePerWeek}
                              name='MaximumPercentagePerWeek'
                              onChange={handleChange('MaximumPercentagePerWeek')}
                              onBlur={() => setFieldTouched('MaximumPercentagePerWeek')}
                            />
                            <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                              {touched.MaximumPercentagePerWeek && errors.MaximumPercentagePerWeek &&
                                <p className='errorMsg'>{errors.MaximumPercentagePerWeek as string}</p>
                              }
                            </div>
                          </div>
                        </div>
                      </div> */}

                      <div
                        className={activeTab === 4 ? 'tab-pane fade show active' : 'tab-pane fade'}
                        role="tabpanel">
                        <Select
                          options={WorkingDaysArray}
                          placeholder="Select working days"
                          isSearchable={true}
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          isMulti
                          onBlur={() => setFieldTouched('WorkingDayNo', true)}
                          onChange={(selectedOption) => {
                            handleChange({
                              target: {
                                id: "WorkingDayNo",
                                value: selectedOption
                              },
                            });
                            handleMultiSelectChange(values, selectedOption);
                          }}

                          value={selectedOptions}
                          name='WorkingDayNo'
                          id='WorkingDayNo'
                        />
                        <div style={{ paddingRight: 5, paddingLeft: 5 }}>
                          {touched.WorkingDayNo && errors.WorkingDayNo &&
                            <p className='errorMsg'>{errors.WorkingDayNo as string}</p>
                          }
                        </div>

                      </div>

                    </div>
                  
                    {Object.keys(errors).length > 0 && (
                      <div className="mt-3 alert alert-danger">
                        <strong>
                        
                          {getValueFromResource('Error Summary', dispatch, t)}

                          :</strong>
                        <ul>
                          {Object.keys(errors).map((fieldName, index) => (
                            <li key={index}>{errors[fieldName] as string}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  
                  </>
                }
              </>}
            </div>
            <div className='card-footer pt-4 '>
              <div className='d-flex flex-stack float-end'>
                <button
                  ref={closeButtonRef}
                  type="button"
                  className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                  id="kt_OffCanvas"
                  onClick={handleCloseOnClickEvent}
                >
                  {/* {t('Cancel')} */}
                  {getValueFromResource('Cancel', dispatch, t)}
                </button>

                <button type="button"
                  className="btn btn-sm btn-primary"
                  onClick={() => handleSubmit()} disabled={!isValid}
                >
                  {/* {t('Save')}   */}
                  {getValueFromResource('Save', dispatch, t)}
                </button>
              </div>
            </div>
          </Fragment>
        )}
      </Formik>
      <ReactTooltip
        id="tooltip-workingDayForm"
        style={TOOLTIP_STYLE}
        place="top"
        delayShow={100}
        delayHide={100}
        clickable
        render={({ content }) => {
          const isLongContent = content && content?.length > 90;
          return (
            <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
              {content}
            </div>
          );
        }}
      />
    </>
  )
}

const colourStyles: StylesConfig = {
  control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

export default WorkingDayTypeForm;

